// extracted by mini-css-extract-plugin
module.exports = {"itemCount":"ItemCount_itemCount__cI2a9"};